import React, { useContext, useEffect, useState } from 'react';
import './NonSelectedSipCard.scss';

import CheckIcon from '@mui/icons-material/Check';
import { UserLoginContext } from '../../../contexts/LoggedInUserContext';
import { fetchSubscriptionAmount, fetchSubscriptionCurrency, getCurrencySymbol } from '../../../services/helperFunctions';


const CAUSE_CONTENT = {
    education: {
        title: "Send them to School",
        subtitle: "Give children with low-income families a chance at education with <span>Amount/month</span>",
        benefits: [
            "Provide them with <span>school supplies</span>",
            "Ensure they receive <span>mid-day meals</span>",
            "<span>Secure</span> their future"
        ],
    },
    animals: {
        title: "Shelter Innocent Strays",
        subtitle: "Provide them with food, water and a lot of love with <span>Amount/month</span>",
        benefits: [
            "Ensure they get <span>medical care</span>",
            "Provide a home at <span>shelters</span>",
            "Fulfil their <span>basic needs</span>"
        ],
    },
    women_girls: {
        title: "Empower Women’s Futures ",
        subtitle: "Support underprivileged women every month by donating <span>Amount/month</span>",
        benefits: [
            "Provide them with <span>job opportunities</span>",
            "Help them <span>gain skills</span>",
            "Boost their <span>financial independence</span>"
        ],
    },
    food_hunger: {
        title: "Stop Them From Sleeping Hungry",
        subtitle: "Feed underprivileged and hungry children every month with <span>Amount/month</span>",
        benefits: [
            "Provide them with <span>monthly rations</span>",
            "End <span>child hunger</span> with every donation",
            "Put a stop to <span>malnutrition in India</span>"
        ],
    },
    medical: {
        title: "Save the Little Ones",
        subtitle: "Get them the medical care they urgently need by donating <span>Amount/month</span>",
        benefits: [
            "Gift access to <span>life-saving treatment</span>",
            "Provide funds for their <span>medications</span>",
            "Aid their <span>families</span> financially"
        ],
    },
    widow: {
        title: "Stand by Abandoned Widows",
        subtitle: "Support struggling widows by donating <span> Amount/month</span>",
        benefits: [
            "Offer safe and ideal <span>living conditions</span>",
            "Help them get <span>financially independent</span>",
            "Support their <span>physical & mental well-being</span>"
        ],
    },
    elderly: {
        title: "Support the Elderly",
        subtitle: "Contribute towards their medical care and essentials with <span>Amount/month</span>",
        benefits: [
            "Ensure <span>medical care</span> and <span>medication</span>",
            "Provide <span>sustainable living conditions</span>",
            "Help them meet their <span>nutritional needs</span>"
        ],
    },
    acid_victims: {
        title: "Support Acid Attack Victims",
        subtitle: "They fought long battles to survive. Contribute <span>Amount/month</span>",
        benefits: [
            "Provide timely <span>medical rehabilitation</span>",
            "<span>Vocational training</span> so they can rebuild their lives",
            "<span>Food and shelter</span> to meet their immediate needs"
        ],
    },


};

const NonSelectedSipCard = ({ campaign_cause = "education" }) => {
    const [content, setContent] = useState(null)
    const { userData, latestOrder } = useContext(UserLoginContext);
    const firstAmount = fetchSubscriptionAmount(latestOrder?.ondemandSubscription, userData?.latest_subscription?.currency);
    const currency = fetchSubscriptionCurrency(latestOrder, userData);

    useEffect(() => {
        setContent(CAUSE_CONTENT[campaign_cause])
    }, [campaign_cause])
    
    firstAmount && content&& (content.subtitle = content.subtitle.replace("Amount", `${getCurrencySymbol(currency)}${firstAmount}`));

    return (
        <>
            {content && <div className="non-subscribed-cause-card">
                <div className='top-section'>
                    <span className='title'>{content.title}</span>
                    <span className="subtitle" dangerouslySetInnerHTML={{ __html: content.subtitle }} />
                </div>

                <div className="benefits-list">
                    {content.benefits.map((benefit, index) => (
                        <li key={index}>
                            <CheckIcon sx={{ color: "#CCCCCC" }} />
                            <span className='benefits-item' dangerouslySetInnerHTML={{ __html: benefit }} />
                        </li>
                    ))}
                </div>
            </div>}
        </>
    );
};

export default NonSelectedSipCard;